import { Controller } from "@hotwired/stimulus"
import { Avatar } from "@dicebear/core"
import { AVATAR_STYLE, AVATAR_OPTIONS } from "../../lib/avatar_options"

export default class extends Controller {
  static values = { seed: String, size: Number }

  connect() {
    this.element.innerHTML = new Avatar(AVATAR_STYLE, {
      ...AVATAR_OPTIONS,
      seed: this.seedValue,
      size: this.sizeValue || 64
    }).toString()
  }
}
